import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('The application root element was not found.');
}
createRoot(rootElement).render(<React.StrictMode data-id="element-658">
    <App data-id="element-659" />
  </React.StrictMode>);